import { Injector, Pipe, PipeTransform } from '@angular/core';
import { AppComponentBase } from '@shared/base/app-component-base';

@Pipe({
    name: 'isGranted',
})
export class IsGrantedPipe extends AppComponentBase implements PipeTransform {
    constructor(injector: Injector) {
        super(injector);
    }

    transform(permission: string): boolean {
        return this.isGranted(permission);
    }
}
